import { createRoot } from 'react-dom/client';
import { App } from './App';

const initApplication = () => {
  const root = createRoot(document.getElementById('root') as HTMLElement);
  root.render(<App />);
};

const withAgentRedirectCheck = async () => {
  try {
    const result = await fetch('/meta');
    const meta = await result.json();

    if (meta.forceRedirectToAgentControlRoom) {
      window.location.href = `/agents/`;
    } else {
      initApplication();
    }
  } catch (_err) {
    initApplication();
  }
};

withAgentRedirectCheck();
